import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { VersionMapQuery, VersionMapQueryVariables } from '../../../../data-access/gql-types/graphql';
import { VERSION_MAP } from '../../../../data-access/queries/devices';
import { isLocalApp } from '../../../../utils/helpers/local-app';
import { useVersionMapStore } from '../../store/version-map';

export const useFetchVersionMap = () => {
  const { skipLavvaFetch } = useInstallationContext();
  const setVersionMap = useVersionMapStore((s) => s.setVersionMap);
  const { data } = useQuery<VersionMapQuery, VersionMapQueryVariables>(VERSION_MAP, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    skip: skipLavvaFetch || isLocalApp,
  });

  useEffect(() => {
    if (data?.versionMap) setVersionMap(data.versionMap);
  }, [data]);
};
